import { OnPremiseSettings } from "../../../Shared/sharedTypes";
import * as types from "../actions/actionTypes";
import { CurrentMentorsActions } from "../actions/currentClientActions";
import initialState from "./initialState";


export default function onPremiseReducer(
    state = initialState.onPremiseSettings,
    action: CurrentMentorsActions
): OnPremiseSettings | null {
    switch (action.type) {
        case types.GET_LIVESWITCH_TOKEN_SUCCESS:
            return {
                onPremiseAppId : action.result.onPremiseAppId!,
                useOnPremiseServer : action.result.useOnPremiseServer
            };
        default:
            return state;
    }
}
